module.exports = __webpack_public_path__ + "img/04-girl.04271ae2.svg";